import fetch from 'isomorphic-fetch';
import ConfigManager from '../common/configManager/configManager';

export const genericApi = (serviceGroup, serviceName, payload) => {
  // Get Service information
  const serviceInfo = ConfigManager.getServiceInfo(serviceGroup, serviceName);

  // URL concatenation
  const url = ConfigManager.getContextRoot() + serviceInfo.name;

  // add headers
  const headers = {};
  headers['Content-Type'] = serviceInfo.content;


  // Request Object
  const requestObject = {
    url,
    options: {
      method: serviceInfo.type,
      headers,
    },
  };
  if (payload != null) {
    requestObject.options.body = JSON.stringify(payload);
  }

  return new Promise((resolve, reject) => {
    fetch(requestObject.url, requestObject)
      .then((response) => {
        resolve(response.json());
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const apiWithUrlParams = (serviceGroup, serviceName, urlParams) => {
  // Get Service information
  const serviceInfo = ConfigManager.getServiceInfo(serviceGroup, serviceName);

  // URL concatenation
  const url = ConfigManager.buildUrl(ConfigManager.getContextRoot(), serviceInfo.name, urlParams);

  // add headers
  const headers = {};
  headers['Content-Type'] = serviceInfo.content;


  // Request Object
  const requestObject = {
    url,
    options: {
      method: serviceInfo.type,
      headers,
    },
  };
  return new Promise((resolve, reject) => {
    fetch(requestObject.url, requestObject.options)
      .then((response) => {
        resolve(response.json());
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const bettingApi = (serviceGroup, serviceName, urlParams) => {
  // Get Service information
  const serviceInfo = ConfigManager.getServiceInfo(serviceGroup, serviceName);

  // URL concatenation
  const url = ConfigManager.buildUrl(ConfigManager.getBettingEndpoint(), serviceInfo.name, urlParams);
  //const url = ConfigManager.getContextRoot() + serviceInfo.name;

  // add headers
  const headers = {};
  headers['Content-Type'] = serviceInfo.content;


  // Request Object
  const requestObject = {
    url,
    options: {
      method: serviceInfo.type,
      headers,
    },
  };
  /* if (payload != null) {
    requestObject.options.body = JSON.stringify(payload);
  }*/

  return new Promise((resolve, reject) => {
    fetch(requestObject.url, requestObject.options)
      .then((response) => {
        resolve(response.json());
      })
      .catch((error) => {
        reject(error);
      });
  });
};




// WEBPACK FOOTER //
// ./src/apiMiddleware/apiMiddleware.js